webpackJsonp([15400075347947],{

/***/ 146:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(25);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactTypist = __webpack_require__(37);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	var _reactBurgerMenu = __webpack_require__(35);
	
	var _reactHelmet = __webpack_require__(36);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _footer = __webpack_require__(27);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _icon = __webpack_require__(28);
	
	var _icon2 = _interopRequireDefault(_icon);
	
	var _menu = __webpack_require__(41);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _phone = __webpack_require__(43);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _tusk = __webpack_require__(44);
	
	var _tusk2 = _interopRequireDefault(_tusk);
	
	var _twitter = __webpack_require__(45);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _heart = __webpack_require__(38);
	
	var _heart2 = _interopRequireDefault(_heart);
	
	var _like = __webpack_require__(40);
	
	var _like2 = _interopRequireDefault(_like);
	
	var _laugh = __webpack_require__(39);
	
	var _laugh2 = _interopRequireDefault(_laugh);
	
	var _message = __webpack_require__(42);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _airplane = __webpack_require__(61);
	
	var _airplane2 = _interopRequireDefault(_airplane);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var privacy = function (_Component) {
	  _inherits(privacy, _Component);
	
	  function privacy(props) {
	    _classCallCheck(this, privacy);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.toggleMenu = function () {
	      _this.setState({ menuOpen: !_this.state.menuOpen });
	    };
	
	    _this.state = {
	      menuOpen: false,
	      isOpen: false,
	      youtubeId: null
	    };
	    return _this;
	  }
	
	  // This keeps your state in sync with the opening/closing of the menu
	  // via the default means, e.g. clicking the X, pressing the ESC key etc.
	
	
	  privacy.prototype.handleStateChange = function handleStateChange(state) {
	    this.setState({ menuOpen: state.isOpen });
	  };
	
	  // This can be used to close the menu, e.g. when a user clicks a menu item
	
	
	  privacy.prototype.closeMenu = function closeMenu() {
	    this.setState({ menuOpen: false });
	  };
	
	  // This can be used to toggle the menu, e.g. when using a custom icon
	  // Tip: You probably want to hide either/both default icons if using a custom icon
	  // See https://github.com/negomi/react-burger-menu#custom-icons
	
	
	  privacy.prototype.render = function render() {
	    var _this2 = this;
	
	    var Signature = _react2.default.createElement(
	      'svg',
	      { viewBox: '0 0 199 143', xmlns: 'http://www.w3.org/2000/svg' },
	      _react2.default.createElement(
	        'g',
	        { id: 'Page-1', fill: 'none', fillRule: 'evenodd', stroke: '#000' },
	        _react2.default.createElement('path', { d: 'M49.1416016,31.1152344 C75.2822266,8.24153646 94.8652344,-1.73730469 107.890625,1.17871094 C127.428711,5.55273438 107.850586,23.5957031 89.9755859,41.9179687 C72.1005859,60.2402344 48.3701172,84.2607422 61.9423828,84.2607422 C75.5146484,84.2607422 190.460938,39.0410156 174.953125,18.2646484 C159.445313,-2.51171875 97.7431641,14.2675781 89.9755859,20.3095703 C82.2080078,26.3515625 59.3632813,35.0810547 94.2402344,61.4013672 C129.117188,87.7216797 146.483398,106.082031 143.764648,119.708008 C141.045898,133.333984 124.748047,142.709961 102.599609,141.464844 C80.4511719,140.219727 63.8066406,137.329102 63.8066406,119.708008 C63.8066406,102.086914 98.2822266,92.1962891 149.499023,79.2382813 C200.71582,66.2802734 212.223633,59.1152344 177.994141,54.3701172 C143.764648,49.625 68.6064453,41.9443359 27.2304687,45.6464844 C-0.353515625,48.1145833 -6.02669271,50.2369792 10.2109375,52.0136719',
	          id: '1-stroke' }),
	        _react2.default.createElement('path', { d: 'M65.0527344,50.0185547 C65.811849,72.8219401 67.96875,89.7386068 71.5234375,100.768555',
	          id: '2-stroke' })
	      )
	    );
	    return _react2.default.createElement(
	      'div',
	      { id: 'outer-container' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Privacy Policy | TUSK, Inc.'
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: 'We draw on decades of corporate, non-profit, and political victories to empower a new generation of innovators with the hard-won context of yesterday and the tools to shape tomorrow.' })
	      ),
	      _react2.default.createElement(
	        _reactBurgerMenu.slide,
	        {
	          pageWrapId: 'page-wrap',
	          width: '75vw',
	          isOpen: this.state.menuOpen,
	          customBurgerIcon: false,
	          onStateChange: function onStateChange(state) {
	            return _this2.handleStateChange(state);
	          },
	          bodyClassName: 'menu-open'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'container py-4' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'mt-4 mb-4' },
	            'New norms. New ideas. New TUSK.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Welcome to the new normal: an evolving idea of what it means to be an influencer, a global citizen, a changemaker. \u201CPolitics\u201D are no longer confined to campaigns. The new social order bends and breaks with every\xA0',
	            _react2.default.createElement(
	              'span',
	              { className: 'icon-animation' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _twitter2.default, height: 24 })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _heart2.default, height: 15, fill: '#e95b4b' })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _like2.default, height: 24, fill: '#238af7' })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _laugh2.default, height: 15 })
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_icon2.default, { icon: _message2.default, height: 15 })
	              )
	            ),
	            '\xA0as disruption reigns supreme. From the classroom to the boardroom\u2014and everywhere in between\u2014agility and insurgency run the show. Get ready.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Even in this unprecedented era, success relies on experience. TUSK draws on decades of corporate, non-profit, and political victories to empower a new generation of innovators with the hard-won context of yesterday and the tools to shape tomorrow.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'The rules have changed. So have we. Labels mean nothing in this new landscape: If you\u2019re trying to do something extraordinary, we want to help.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'So. Let\u2019s get started.'
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'ron' },
	            Signature,
	            _react2.default.createElement(
	              'div',
	              { className: 'h6 mb-0 mt-3' },
	              '- Ron Steslow'
	            ),
	            _react2.default.createElement(
	              'i',
	              null,
	              'President, TUSK INC'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-6' },
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contact', role: 'button', tabIndex: 0, className: 'mt-5 btn btn-secondary btn-block' },
	                'Let\'s Talk'
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'page-wrap' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid d-md-block d-none' },
	          _react2.default.createElement(
	            'div',
	            { className: 'pt-3 pb-5' },
	            _react2.default.createElement(
	              'button',
	              { className: 'btn btn-primary', onClick: function onClick() {
	                  return _this2.toggleMenu();
	                } },
	              _react2.default.createElement(_icon2.default, { icon: _menu2.default, width: 24, height: 30, fill: '#fff' })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'container-fluid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'row' },
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-5 logo-area' },
	              _react2.default.createElement(
	                'button',
	                { className: 'btn btn-primary d-inline-block d-md-none', onClick: function onClick() {
	                    return _this2.toggleMenu();
	                  } },
	                _react2.default.createElement(_icon2.default, { icon: _menu2.default, width: 24, height: 30, fill: '#fff' })
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/', className: 'logo', href: '#' },
	                _react2.default.createElement(_icon2.default, { icon: _tusk2.default, height: 70, fill: '#000' })
	              ),
	              _react2.default.createElement(
	                'h2',
	                { className: 'tagline' },
	                'Footnotes to Frontrunners.'
	              ),
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/contact', className: 'd-inline-block d-md-none btn btn-primary' },
	                _react2.default.createElement(_icon2.default, { icon: _airplane2.default, width: 24, height: 30, fill: '#fff' })
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'd-none d-md-inline-block' },
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/', role: 'button', tabIndex: 0, className: 'd-none d-md-inline-block mt-md-4 btn btn-lg btn-secondary mr-2' },
	                  'Home'
	                ),
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: '/contact', role: 'button', tabIndex: 0, className: 'd-none d-md-inline-block mt-md-4 btn btn-lg btn-secondary' },
	                  'Let\'s Talk'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'col-md-7 py-3 ml-auto' },
	              _react2.default.createElement(
	                _reactTypist2.default,
	                { className: 'h1 mb-5 ml-0 ml-md-4' },
	                'Privacy policy.'
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'px-md-4 pl-0' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'This Web site is the responsibility of Tusk Digital. If you have questions regarding the Agreement or the practices of Tusk Digital, please contact us by e-mail or regular mail.'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'The Tusk Digital Commitment to Privacy'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Your privacy is important to us. To better protect your privacy Tusk Digital provide this notice explaining our online information practices and the choices you can make about the way your information is collected and used. To make this notice easy to find, Tusk Digital has made it available on our homepage and at every point where personally identifiable information may be requested. The Information Tusk Digital Collects: This notice applies to all information collected or submitted at www.TuskDigital.com. On some pages, you can order products, make requests, and register to receive materials. The types of personal information collected at these pages are:'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Name'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Address'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Email Address'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Phone number'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Credit/Debit Card Information'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'On some pages, you can submit information about other people. For example, if you order a gift online and want it sent directly to the recipient, you will need to submit the recipient\'s address. In this circumstance, the types of personal information collected are:'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Name'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Address'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Phone number'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'The Way Tusk Digital Uses Information:'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Tusk Digital uses the information you provide about yourself when placing an order only to complete that order. Tusk Digital does not share this information with outside parties except to the extent necessary to complete that order. Tusk Digital uses the information you provide about someone else when placing an order only to ship the product and to confirm delivery. Tusk Digital does not share this information with outside parties except to the extent necessary to complete that order. Tusk Digital uses return email addresses to answer email that we receive. Such addresses are not shared with outside parties.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Tusk Digital uses non-identifying and aggregate information to better design our TuskDigital.com site and to share with advertisers. For example, evoesk may tell an advertiser that X number of individuals visited a certain area on our Tusk Digital website, or that Y number of men and Z number of women filled out our registration form, but Tusk Digital would not disclose anything that could be used to identify those individuals. Finally, Tusk Digital never uses or share the personally identifiable information provided to us online in ways unrelated to the ones described above without also providing you an opportunity to opt-out or otherwise prohibit such unrelated uses.'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'Our Commitment To Data Security'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'To prevent unauthorized access, maintain data accuracy, and ensure the correct use of information, Tusk Digital has put in place appropriate physical, electronic, and managerial procedures to safeguard and secure the information TuskDigital.com collects online.'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'Our Commitment to Children\'s Privacy:'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Protecting the privacy of the very young is especially important. For that reason, Tusk Digital never collects or maintain information at TuskDigital.com from those we actually know are under 13, and no part of our Tusk Digital.com is structured to attract anyone under 13. How You Can Access or Correct Your Information'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'You can access all your personally identifiable information that Tusk Digital collects online and maintain by calling us and verifying your identitiy. Tusk Digital.com uses this procedure to better safeguard your information. You can correct factual errors in your personally identifiable information by sending us a request that credibly shows error. To protect your privacy and security, Tusk Digital will also take reasonable steps to verify your identity before granting access or making corrections.'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'Tusk Digital\'s Right to Contact User.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Tusk Digital reserves the right to contact site visitors regarding account status and changes to the subscriber agreement, privacy policy, or any other policies or agreements relevant to site visitors.'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'Tusk Digital\'s Right to Change Privacy Policy.'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Tusk Digital reserves the right to change this policy at any time by notifying visitors of the existence and location of the new or revised privacy policy.'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  null,
	                  'How To Contact Us'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  'Should you have other questions or concerns about these privacy policies, please send contact us by filling out the form ',
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: '/contact' },
	                    'here'
	                  ),
	                  '.'
	                )
	              ),
	              _react2.default.createElement(_footer2.default, null)
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return privacy;
	}(_react.Component);
	
	exports.default = privacy;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-js-1f018eec21745d72e4d7.js